



















































import Vue from 'vue';
import Login from './Login.vue';
import { MUTATIONS } from "@/shared/store";
import { mapGetters, mapState, mapMutations } from 'vuex';

export default Vue.extend({
  components: {
    Login,
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState(["username", "error"]),
  },
  methods: {
    ...mapMutations({
      logout: MUTATIONS.LOGOUT
    })
  }
});
